import { CommonConstants } from 'src/app/shared/constant';

export const GridSetting = {
  buttonCount: 5,
  info: true,
  type: 'numeric',
  pageSizes: [20, 50, 100, 200],
  previousNext: true,
  defaultSkip: 0,
  defaultTake: 20,
  defaultSortOrder: 'desc',
};

export const allRecordsTake: number = 5000;

export interface IFilterPaginationDto {
  filter: IFilter[];
  paging: IPagination;
}

export interface IPagination {
  skip: number;
  take: number;
  sort: ISort;
}

export interface ISort {
  sortBy: string;
  sortDirection: number;
}

export interface IFilter {
  field: string;
  operator: CommonConstants.FilterOperator;
  value: string;
}
